import styled from 'styled-components';
import ds from 'designsystem/index';

const Background = styled.div`
  background-color: ${ds.brand('product')};
  min-height: 280px;
  `;

export default Background;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/Background.jsx